import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPackageListByCompanyId, getGroupInfoList, getExcludeInfoList } from '@/api/module/index';
import { getOrderCount, getSetBookedTime as _getSetBookedTime, getSelfCheckGroups, unbindingWechat, getUnitBookedDateByBookedNo, updateOrderBookedDateUnit } from '@/api/module/user';
import { getNextMonth, getNow, formatDate } from '@/assets/utils/dateUtil';
import { Dialog, Toast } from "vant";
import { decrypt } from "@/assets/utils/cryptoUtil";
export default {
  name: "index",
  data: function data() {
    return {
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      VUE_APP_HIDE_MONEY_COMPANYIDS: window.g.VUE_APP_HIDE_MONEY_COMPANYIDS,
      additionalAutoadd: window.g.VUE_APP_ADDITIONAL_AUTOADD,
      //预约关联项目材料费附加费是否自动关联
      result: [],
      packageTypes: [],
      //套餐分组
      activePackagetype: 0,
      activePackagetypeId: '01',
      initPackageList: [],
      packageList: [],
      //套餐列表
      typeFirstSelected: 0,
      typeSecondSelected: 0,
      date: '',
      active: 0,
      active1: 0,
      show: false,
      showCheckedPackages: false,
      showChooseGroup: false,
      showChose: true,
      // 控制下一步POP
      showPackageDetail: false,
      showDate: false,
      checkedDate: undefined,
      //页面传递的预约体检时间
      checkDate: undefined,
      //当前选择的预约体检时间
      packageDetail: {},
      //套餐详情数据
      packageamount: 0,
      //套餐总价
      total: 0,
      radio: 1,
      checkedPackages: [],
      //已选套餐
      checkedPackageIds: [],
      //已选套餐ID
      checkedPackageNames: [],
      //
      radio1: 1,
      checkbox: false,
      checkboxGroup: [],
      minDate: new Date(),
      maxDate: new Date(),
      deptArr: [],
      //科室列表
      groups: [],
      //科室筛选后的加项项目
      data: [],
      datas: [],
      //所有组合项目对象
      checkDeptStr: '',
      //当前选中的科室名称
      disableGroup: [],
      //套餐组合，默认显示，默认禁止
      excludeInfoList: [],
      //组合排斥关联
      disabledExclude: [],
      //排斥组合
      packageGroup: [],
      //套餐内项目
      chooseGroup: [],
      //已选加做项目
      groupPrice: 0,
      //已选加做组合价格
      orderCount: [],
      //预约排班
      orderArr: new Array(),
      setBookedTime: [],
      //可约的时间段设置
      setBookedTimeSelected: undefined,
      setBookedTimeSelectedTxt: undefined,
      user: {},
      //登录用户信息
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      //医院地址
      showSuccess: false,
      bookedPatient: {},
      //父页面参数数据
      orderWeektime: [],
      //一周可预约日期
      showAdd: false,
      //增加项目
      showDel: false,
      //删除项目
      delresult: [],
      //需要删除的项目ID
      //小球
      ball: {
        el: null,
        show: false,
        imgSrc: require("@/assets/images/package/package-default.jpg")
      },
      amount: 0,
      actualAmount: 0,
      discount: 1,
      selfAmount: 0,
      //个人支付金额
      settlementMode: '1' //结算方式 默认按套餐

    };
  },
  created: function created() {
    var _this2 = this;

    this.user = JSON.parse(localStorage.getItem("loginuser"));

    if (this.user.sexid == null || this.user.sexid == undefined || this.user.sexid == "" || this.user.sexid == "0" || this.user.cardid == null || this.user.cardid == undefined || this.user.cardid == "") {
      Dialog.alert({
        message: "信息不全，检查性别和身份证设置，请先补全基本信息再预约"
      }).then(function () {
        _this2.$router.push({
          name: 'edituser'
        });
      });
      return;
    }

    var bookedPatient = JSON.parse(this.$route.query.item);
    this.bookedPatient = bookedPatient;
    this.packageTypes.push({
      text: '基础套餐'
    });
    this.packageTypes.push({
      text: '专病套餐'
    });

    if (bookedPatient.isReplaceItem != "0") {
      this.packageTypes.push({
        text: '自选项目'
      });
    }

    this.checkedDate = bookedPatient.checkDate;
    this.settlementMode = bookedPatient.settlementMode;
    this.getPackageList(bookedPatient.companyID, bookedPatient.companyTime);
    setTimeout(function () {
      //查询加做项目
      _this2.getSetBookedTime(_this2.checkedDate);

      _this2.getCount();
    }, 300);
    this.$nextTick(function () {
      //元素加载完成后执行的代码
      if (_this2.bookedPatient.bookedType == "2") {
        _this2.showChecked();
      }
    });
  },
  filters: {
    valueFilter: function valueFilter(value) {
      if (value == null || value == '') {
        return '';
      } else {
        return value;
      }
    },
    setBookedTimeFilter: function setBookedTimeFilter(value) {
      return value.starttime + ' ~ ' + value.endtime;
    },
    filterMoney: function filterMoney(value, showMoney) {
      if (showMoney) {
        return '（￥' + value + '）';
      } else {
        return "";
      }
    },
    settlementModeFilter: function settlementModeFilter(value) {
      switch (value) {
        case '1':
          {
            return "按项目";
            break;
          }

        case '2':
          {
            return "套餐+项目";
            break;
          }

        case '3':
          {
            return "单位+个人分别折扣";
            break;
          }

        case '4':
          {
            return "优惠固定金额";
            break;
          }

        case '5':
          {
            return "套餐（允许退项）";
            break;
          }
      }
    }
  },
  methods: {
    //计算showMoney的值
    getsingleShowMoney: function getsingleShowMoney(companyID) {
      var singleShowMoney = true;

      if (this.showMoney) {
        if (Array.isArray(this.VUE_APP_HIDE_MONEY_COMPANYIDS)) {
          if (companyID != undefined && this.VUE_APP_HIDE_MONEY_COMPANYIDS.includes(companyID.substring(0, 4))) {
            singleShowMoney = false;
          }
        }
      }

      return singleShowMoney;
    },
    //查询加做项目
    getSelfCheck: function getSelfCheck() {
      var _this3 = this;

      var param = {
        bookedNo: this.bookedPatient.bookedNo
      };
      getSelfCheckGroups(param).then(function (res) {
        if (res.code == 200) {
          res.data.forEach(function (item) {
            _this3.result.push(item.groupID);
          });
        }
      });
    },
    //查询预约排班
    getCount: function getCount() {
      var _this4 = this;

      var _this = this;

      var companyid = this.bookedPatient.companyID;

      if (companyid.length > 4) {
        companyid = companyid.substring(0, 7);
      } else {
        companyid = companyid.substring(0, 4);
      }

      var params = {
        companyid: companyid,
        companytimes: this.bookedPatient.companyTime,
        checkline: this.bookedPatient.enterQueue,
        institutionid: window.g.VUE_APP_INSTITUTIONID
      };
      getOrderCount(params).then(function (res) {
        if (res.code == 200) {
          _this4.orderCount = res.data;
          console.log(_this4.orderCount);
          var currDatetime = "";
          var currDatetimeIsCount = false;

          _this4.orderCount.forEach(function (item) {
            if (item.womennumber > 0 || item.mennumber > 0) {
              if (item.womennumber - item.alreadywomen > 0 || item.mennumber - item.alreadymen > 0) {
                if (!currDatetimeIsCount && item.bookeddate > _this4.getNow()) {
                  currDatetime = item.bookeddate;
                  currDatetimeIsCount = true;
                }
              }
            } else if (item.bookednumber > 0) {
              if (item.bookednumber - item.already) {
                if (!currDatetimeIsCount && item.bookeddate > _this.getNow()) {
                  currDatetime = item.bookeddate;
                  currDatetimeIsCount = true;
                }
              }
            }

            _this.orderArr.push(item.bookeddate + '');
          });

          _this.maxDate = getNextMonth();
          setTimeout(function () {
            if (currDatetime == "") {
              _this.orderWeektime = _this.getWeekTime();
            } else {
              _this.orderWeektime = _this.getWeekTime(currDatetime);
            } // 2024-02-28 ZLS 查询当前日期列表 是否有可预约的日期 有则自动选择当前日期


            var param = {
              bookedNo: _this.bookedPatient.bookedNo
            };
            getUnitBookedDateByBookedNo(param).then(function (res) {
              if (res.code == 200) {
                if (res.data) {
                  _this.setBookedTime.some(function (item) {
                    if (res.data.timeslot == item.id) {
                      _this.setBookedTimeSelected = item.id;
                      return true;
                    }
                  });

                  _this.orderWeektime.some(function (jtem) {
                    if (res.data.checkdate == jtem.date) {
                      console.log("checkDate", jtem);
                      _this.checkDate = jtem.date;
                      return true;
                    }
                  });
                }

                console.log("时间和时间段", res);
              }
            });
          }, 30);
        }
      });
    },
    getExcludes: function getExcludes() {
      var _this5 = this;

      getExcludeInfoList().then(function (res) {
        if (res.code == 200) {
          _this5.excludeInfoList = res.data; //默认的也要⛏

          _this5.exclude();
        }
      });
    },
    getGroups: function getGroups() {
      var _this6 = this;

      var _this = this;

      var param = {
        institutionId: window.g.VUE_APP_INSTITUTIONID
      };
      this.getSelfCheck();
      getGroupInfoList(param).then(function (res) {
        if (res.code == 200) {
          res.data.forEach(function (item) {
            _this6.result.filter(function (jtem) {
              if (item.groupId == jtem) {
                _this6.chooseGroup.push(item);

                _this6.groupPrice = parseFloat(_this6.groupPrice) + parseFloat(item.actualPrice);
              }
            });
          });
        }

        _this6.computeAmount();
      });
    },
    getPackageList: function getPackageList(companyId, companyTimes) {
      var _this7 = this;

      var param = {
        companyId: companyId,
        companyTimes: companyTimes
      };
      getPackageListByCompanyId(param).then(function (res) {
        if (res.code == 200) {
          var userSex = _this7.user.sexid;
          res.data.forEach(function (item) {
            item.price = decrypt(item.priceStr);
            item.actualPrice = decrypt(item.actualPriceStr);
          });
          _this7.initPackageList = res.data.filter(function (item) {
            return item.sexId == userSex || item.sexId == '0';
          });
          var bookedpackageList = _this7.bookedPatient.bookedpackageList;
          var packageList = [];

          if (bookedpackageList != null && bookedpackageList.length > 0) {
            _this7.initPackageList.forEach(function (item) {
              bookedpackageList.forEach(function (jtem) {
                if (item.packageId == jtem.packageid) {
                  console.log(jtem.packageid);
                  item.modify = jtem.modify;
                  item.isSelected = true;
                  console.log("item", item);

                  _this7.checkedPackages.push(item);

                  _this7.checkedPackageIds.push(item.packageId);

                  _this7.checkedPackageNames.push(item.packageName);

                  if (item.packageType == '01') {
                    _this7.typeFirstSelected++;
                    _this7.packageTypes[0].badge = _this7.typeFirstSelected;
                    packageList.push(item);
                  }

                  if (item.packageType == '02') {
                    _this7.typeSecondSelected++;
                    _this7.packageTypes[1].badge = _this7.typeSecondSelected;
                  }
                }
              });
            });
          } else {
            _this7.initPackageList.forEach(function (item) {
              if (item.packageType == '01') {
                packageList.push(item);
              }
            });
          }

          _this7.checkedPackages = _this7.sortByKey(_this7.checkedPackages, 'modify', true);
          _this7.packageList = packageList;
          _this7.packageTypes[0].text = '基础套餐(' + _this7.packageList.length + ')'; //选择这个客户导入的套餐

          _this7.getGroups();

          _this7.getExcludes();

          _this7.checkDept(_this7.checkDeptStr);
        }
      });
    },
    //数组排序 array 数组 key  字段 order true 升序 false  降序
    sortByKey: function sortByKey(array, key, order) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];

        if (order) {
          return x < y ? -1 : x > y ? 1 : 0;
        } else {
          return x < y ? x > y ? 1 : 0 : -1;
        }
      });
    },
    checkDept: function checkDept(name) {
      var groupsTemp = [];
      this.groups = [];
      this.checkDeptStr = name; //根据科室名称过滤组合
      //判断性别是否适用

      var userSex = this.user.sexid;
      this.datas.forEach(function (item) {
        //过滤禁用、性别不适用项目、终端显示
        if (item.departmentName == name && item.isEnable == "1" && item.serviceShow != '2') {
          if (userSex == '2') {
            if (item.sexId != '1') {
              groupsTemp.push(item);
            }
          } else if (userSex == '1') {
            if (item.sexId != '2') {
              groupsTemp.push(item);
            }
          } else {
            groupsTemp.push(item);
          }
        }
      });
      this.groups = groupsTemp;
      this.checkSex();
      this.exclude();
    },
    showDetail: function showDetail(id) {
      var _this8 = this;

      //通过套餐ID查询套餐详情
      this.showPackageDetail = true;
      this.initPackageList.forEach(function (item) {
        if (item.packageId == id) {
          _this8.packageDetail = item;
        }
      });
      this.$nextTick(function () {
        if (this.packageDetail != null) {
          if (this.packageDetail.basicGroupInfos != undefined) {
            this.total = this.packageDetail.basicGroupInfos.length;
          }
        }
      });
    },
    detail: function detail(item) {
      if (item != '') {
        Dialog.alert({
          title: '检查意义',
          message: item
        }).then(function () {});
      }
    },
    showChecked: function showChecked() {
      var _this = this;

      setTimeout(function () {
        _this.computeAmount();
      }, 600);
      this.showChose = true;
    },
    //计算金额
    computeAmount: function computeAmount() {
      var _this9 = this;

      this.packageamount = 0;
      var amount = 0;
      var actualAmount = 0;
      var unitQuota = this.bookedPatient.unitQuota;

      if (isNaN(unitQuota)) {
        unitQuota = 0;
      }

      var packagePrice = parseFloat(this.bookedPatient.packagePrice);
      var discount = parseFloat(this.bookedPatient.discount);
      var selfAmount = 0;
      var unDiscountItems = [];
      var discountItems = [];
      var unDiscountPrice = 0;
      var prevBasicGroupInfos = [];
      var deductionAmount = 0;
      this.checkedPackages.forEach(function (item, i) {
        _this9.packageamount += item.actualPrice;
        item.basicGroupInfos.forEach(function (gtem) {
          if (i > 0) {
            prevBasicGroupInfos.forEach(function (jtem) {
              if (gtem.groupId == jtem.groupId) {
                gtem.isDelete = '2';
                deductionAmount += gtem.price;
              }
            });
          }

          if (gtem.isDelete == "2") {} else {
            amount += gtem.price;
          }

          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            discountItems.push(gtem);
          } else {
            unDiscountItems.push(gtem);
            unDiscountPrice += gtem.price;
          }
        });
        prevBasicGroupInfos = prevBasicGroupInfos.concat(item.basicGroupInfos);
      }); //套餐总金额

      this.packageamount = this.packageamount - deductionAmount;
      this.chooseGroup.forEach(function (item) {
        amount += item.price;

        if (item.allowDiscount == "1") {
          discountItems.push(item);
        } else {
          unDiscountItems.push(item);
          unDiscountPrice += item.price;
        }
      });

      if (amount != 0) {
        switch (this.bookedPatient.settlementMode) {
          //按项目
          case '1':
          case '4':
            {
              selfAmount = amount * discount - packagePrice;
              this.selfAmount = selfAmount.toFixed(2);
              actualAmount = (unitQuota + selfAmount).toFixed(2); //计算实际折扣

              var realDiscount = (actualAmount - unDiscountPrice) / (amount - unDiscountPrice);
              console.log("实际折扣：" + realDiscount);
              this.updateGroupsPrice(realDiscount); //更新项目实收价格

              this.floatingGroupsPrice(); //抹平价差

              break;
            }
          //套餐+项目

          case '2':
          case '5':
            {
              //如果未设置项目配额->按套餐+项目
              selfAmount = this.packageamount + this.groupPrice * discount - unitQuota;
              this.selfAmount = selfAmount.toFixed(2);
              actualAmount = (unitQuota + selfAmount).toFixed(2);
              console.log('更新价格前：' + selfAmount);
              console.log('更新价格前：' + actualAmount);
              this.updatePackageGroupsPrice(); //更新套餐项目实收价格

              this.floatingPackageGroupsPrice(); //抹平套餐价差

              break;
            }
          //单位+个人分别折扣

          case '3':
            {
              if (isNaN(packagePrice)) {
                packagePrice = unitQuota;
              }

              selfAmount = (amount - packagePrice) * discount;
              this.selfAmount = selfAmount.toFixed(2);
              actualAmount = (unitQuota + selfAmount).toFixed(2);
              console.log("我进来了", unitQuota); //计算实际折扣

              var _realDiscount = (actualAmount - unDiscountPrice) / (amount - unDiscountPrice);

              console.log("实际折扣：" + _realDiscount);
              this.updateGroupsPrice(_realDiscount); //更新项目实收价格

              this.floatingGroupsPrice(); //抹平价差

              break;
            }
        }
      }

      this.amount = amount.toFixed(2);
      this.actualAmount = actualAmount;
      this.discount = discount;
      console.log("结算方式：" + this.bookedPatient.settlementMode);
      console.log("原价金额：" + this.amount);
      console.log("实收金额：" + this.actualAmount);
      console.log("套餐金额：" + this.packageamount);
      console.log("加做金额：" + this.groupPrice * discount);
      console.log("单位支付：" + unitQuota);
      console.log("项目配额：" + packagePrice);
      console.log("自付金额：" + this.selfAmount);
      this.checkGroupsPrice(); //验证项目实收价格
    },
    //更新套餐项目实收价格
    updatePackageGroupsPrice: function updatePackageGroupsPrice() {
      this.checkedPackages.forEach(function (item) {
        //计算每个套餐的实际折扣（去除不允许折扣项目的金额）
        var notAllowDiscountAmount = 0;
        item.basicGroupInfos.forEach(function (gtem) {
          if (gtem.allowDiscount != "1" || gtem.isDelete == "2") {
            notAllowDiscountAmount += gtem.price;
          }
        });
        var realDiscount = (item.actualPrice - notAllowDiscountAmount) / (item.price - notAllowDiscountAmount); //更新套餐内允许折扣项目的时候金额

        item.basicGroupInfos.forEach(function (gtem) {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            gtem.actualPrice = (gtem.price * realDiscount).toFixed(2);
          }
        });
      });
    },
    //抹平套餐价差
    floatingPackageGroupsPrice: function floatingPackageGroupsPrice() {
      this.checkedPackages.forEach(function (item) {
        var actualAmount = 0;
        var notAllowDiscountAmount = 0;
        var maxIndex = 0;
        var maxPrice = 0;
        item.basicGroupInfos.forEach(function (gtem, i) {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice);

            if (parseFloat(gtem.actualPrice) > maxPrice) {
              maxPrice = parseFloat(gtem.actualPrice);
              maxIndex = i;
            }
          } else {
            notAllowDiscountAmount += parseFloat(gtem.price);
          }
        });

        if (actualAmount != parseFloat(item.actualPrice - notAllowDiscountAmount)) {
          var diff = parseFloat(item.actualPrice - notAllowDiscountAmount) - actualAmount;
          var tempPrice = item.basicGroupInfos[maxIndex].actualPrice;
          item.basicGroupInfos[maxIndex].actualPrice = parseFloat(tempPrice) + diff;
        }
      });
    },
    //更新项目实收价格
    updateGroupsPrice: function updateGroupsPrice(realDiscount) {
      this.checkedPackages.forEach(function (item, i) {
        item.basicGroupInfos.forEach(function (gtem) {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            gtem.actualPrice = (gtem.price * realDiscount).toFixed(2);
          }
        });
      });
      this.chooseGroup.forEach(function (item) {
        if (item.allowDiscount == "1") {
          item.actualPrice = (item.price * realDiscount).toFixed(2);
        }
      });
    },
    //抹平价差
    floatingGroupsPrice: function floatingGroupsPrice() {
      var actualAmount = 0;
      var maxIndex = 0;
      var maxPrice = 0;
      var flag = 0;
      var pIndex = 0;
      this.checkedPackages.forEach(function (item, pi) {
        item.basicGroupInfos.forEach(function (gtem, i) {
          if (gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice);

            if (parseFloat(gtem.actualPrice) > maxPrice) {
              maxPrice = parseFloat(gtem.actualPrice);
              maxIndex = i;
              pIndex = pi;
            }
          }
        });
      });
      this.chooseGroup.forEach(function (item, i) {
        actualAmount += parseFloat(item.actualPrice);

        if (parseFloat(item.actualPrice) > maxPrice) {
          maxPrice = parseFloat(item.actualPrice);
          maxIndex = i;
          flag = 1;
        }
      }); //抹平价差

      if (parseFloat(this.actualAmount) != actualAmount) {
        var diff = parseFloat(this.actualAmount) - actualAmount;
        console.log("actualAmount：" + actualAmount);
        console.log("价差：" + diff);

        if (flag == 0) {
          this.checkedPackages.forEach(function (item, pi) {
            if (pi == pIndex) {
              item.basicGroupInfos.forEach(function (gtem, i) {
                if (i == maxIndex) {
                  gtem.actualPrice = (parseFloat(gtem.actualPrice) + diff).toFixed(2);
                }
              });
            }
          });
        } else {
          this.chooseGroup.forEach(function (item, i) {
            if (i == maxIndex) {
              item.actualPrice = (parseFloat(item.actualPrice) + diff).toFixed(2);
            }
          });
        }
      }
    },
    //验证项目实收价格
    checkGroupsPrice: function checkGroupsPrice() {
      var actualAmount = 0;
      this.checkedPackages.forEach(function (item, pi) {
        item.basicGroupInfos.forEach(function (gtem, i) {
          if (gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice);
          }
        });
      });
      this.chooseGroup.forEach(function (item, i) {
        actualAmount += parseFloat(item.actualPrice);
      });
      console.log("验证实收金额：" + actualAmount.toFixed(2));
    },
    formatter: function formatter(day) {
      var _this10 = this;

      var year = day.date.getFullYear();
      var month = day.date.getMonth() + 1;
      var date = day.date.getDate();

      if (month < 10) {
        month = '0' + month;
      }

      if (date < 10) {
        date = '0' + date;
      }

      var days = year + '-' + month + '-' + date;
      this.orderCount.forEach(function (item) {
        if (item.bookeddate == days) {
          if (item.status == '0') {
            day.bottomInfo = '不可约';
            day.type = "disabled";
          } else if (item.status == '1') {
            var personCount = 0;

            if (parseInt(item.mennumber) > 0 || parseInt(item.womenmumber) > 0) {
              if (_this10.user.sexid == "1") {
                personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
              }

              if (_this10.user.sexid == "2") {
                personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
              }
            } else {
              personCount = parseInt(item.bookednumber) - parseInt(item.already);
            }

            if (personCount <= 0) {
              day.bottomInfo = '已约满';
              day.type = "disabled";
            } else {
              if (days <= _this10.getNow()) {
                day.type = "disabled";
                day.bottomInfo = '不可约';
              } else {
                day.bottomInfo = '余 ' + personCount;
              }
            }
          }
        }
      }); //将所有的没有排期的设置为休息日

      if (!this.orderArr.includes(days)) {
        var nextMonthStr = "";
        var nextMonth = getNextMonth();
        var nextM = nextMonth.getMonth() + 1;
        var nextD = nextMonth.getDate();

        if (nextM < 10) {
          nextM = '0' + nextM;
        }

        if (nextD < 10) {
          nextD = '0' + nextD;
        }

        nextMonthStr = nextMonth.getFullYear() + '-' + nextM + '-' + nextD; //已经过去的时间不显示文字

        if (days >= getNow() && days <= nextMonthStr) {
          day.bottomInfo = '不可约';
          day.type = "disabled";
        }
      }

      return day;
    },
    selectDate: function selectDate(date) {
      var newDate = new Date();
      this.showDate = false;

      if (formatDate(date) == formatDate(new Date())) {
        return;
      }

      this.checkDate = formatDate(date);
      this.orderWeektime = this.getWeekTime(this.checkDate);
      console.log("体检日期" + this.checkDate);
      this.getSetBookedTime(this.checkDate);
    },
    setBookedTimeClick: function setBookedTimeClick(item) {
      if (item.surplus > 0) {
        this.setBookedTimeSelected = item.id;
        this.setBookedTimeSelectedTxt = item.starttime + " ~ " + item.endtime;
      }
    },
    selectWeekDate: function selectWeekDate(item) {
      if (item.type) {
        return;
      }

      console.log(item.date);
      this.checkDate = item.date;
      this.$refs.allDate.reset(new Date(this.checkDate));
      this.getSetBookedTime(this.checkDate);
    },
    getNow: function getNow() {
      var d = new Date();
      var yy1 = d.getFullYear();
      var mm1 = d.getMonth() + 1;

      if (mm1 < 10) {
        mm1 = '0' + mm1;
      }

      var dd1 = d.getDate();

      if (dd1 < 10) {
        dd1 = '0' + dd1;
      }

      return yy1 + '-' + mm1 + '-' + dd1;
    },
    getWeekTime: function getWeekTime(dateParam) {
      var _this11 = this;

      // var new_Date = new Date(2021,11,10) //获取指定日期当周的一周日期
      var new_Date = new Date(); //获取本周一周日期

      if (this.orderArr.length > 0) {
        new_Date = new Date(this.orderArr[0]);
      }

      if (dateParam != undefined) {
        new_Date = new Date(dateParam);
      }

      var timesStamp = new_Date.getTime();
      var currenDay = new_Date.getDay();
      var dates = [];

      var _loop = function _loop() {
        das = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7)); // var dasStr = das.toLocaleDateString();

        var year = das.getFullYear();
        var month = das.getMonth() + 1;
        var date = das.getDate();

        if (month < 10) {
          month = '0' + month;
        }

        if (date < 10) {
          date = '0' + date;
        }

        var days = year + '-' + month + '-' + date;
        weekObj = {};
        weekObj.index = i;
        weekObj.date = days; // das.replace(/[年月]/g, '.').replace(/[日上下午]/g, '');

        weekObj.day = das.getMonth() + 1 + '/' + das.getDate();
        weekObj.week = _this11.getWeekName(das.getDay());
        weekObj.type = true;
        weekObj.number = '不可约';

        if (das.getDay() == 6 || das.getDay() == 0) {
          weekObj.type = true;
          weekObj.number = '不可约';
        }

        if (_this11.orderArr.length > 0) {
          _this11.orderCount.forEach(function (item) {
            if (item.bookeddate == days) {
              if (item.status == '0') {
                weekObj.number = '不可约';
                weekObj.type = true;
              } else if (item.status == '1') {
                var personCount = 0;

                if (parseInt(item.mennumber) > 0 || parseInt(item.womennumber) > 0) {
                  if (_this11.user.sexid == "1") {
                    personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
                  }

                  if (_this11.user.sexid == "2") {
                    personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
                  }
                } else {
                  personCount = parseInt(item.bookednumber) - parseInt(item.already);
                }

                if (personCount <= 0) {
                  weekObj.number = '已约满';
                  weekObj.type = true;
                } else {
                  if (days <= _this11.getNow()) {
                    weekObj.type = true;
                    weekObj.number = '不可约';
                  } else {
                    weekObj.type = false;
                    weekObj.number = '余 ' + personCount;
                  }
                }
              }
            }
          });
        }

        dates.push(weekObj);
      };

      for (var i = 0; i < 7; i++) {
        var das;
        var weekObj;

        _loop();
      }

      return dates;
    },
    getWeekName: function getWeekName(day) {
      switch (day) {
        case 1:
          {
            return "周一";
            break;
          }

        case 2:
          {
            return "周二";
            break;
          }

        case 3:
          {
            return "周三";
            break;
          }

        case 4:
          {
            return "周四";
            break;
          }

        case 5:
          {
            return "周五";
            break;
          }

        case 6:
          {
            return "周六";
            break;
          }

        case 0:
          {
            return "周日";
            break;
          }

        default:
          {
            return "";
          }
      }
    },
    //将不适用性别的组合禁用掉
    checkSex: function checkSex() {
      var _this12 = this;

      this.disableGroup = []; //判断性别是否适用

      var userSex = this.user.sexid;

      if (userSex == "2") {
        //女
        //过滤男性组合
        this.groups.forEach(function (item) {
          if (item.sexId == '1' && item.sexId != '0') {
            _this12.disableGroup.push(item.groupId);
          }
        });
      } else if (userSex == "1") {
        //男
        //过滤女性组合
        this.groups.forEach(function (item) {
          if (item.sexId == '2' && item.sexId != '0') {
            _this12.disableGroup.push(item.groupId);
          }
        });
      } //将套餐内包含的项目禁用掉


      this.groups.forEach(function (item) {
        _this12.checkedPackages.forEach(function (jtem) {
          jtem.basicGroupInfos.forEach(function (ktem) {
            if (item.groupId == ktem.groupId) {
              _this12.disableGroup.push(item.groupId);
            }
          });
        });
      });
    },
    //清空已选项目
    clearGroups: function clearGroups() {
      var _this13 = this;

      Dialog.confirm({
        title: '提示',
        message: '您确定要清空已选加做项目吗？'
      }).then(function () {
        Toast('已清空已选加做项目');
        _this13.result = [];
        _this13.chooseGroup = [];
        _this13.packageTypes[2].badge = 0;

        _this13.computeAmount();
      }).catch(function () {// on cancel
      });
    },
    //预约
    orderNow: function orderNow() {
      if (this.checkDate == undefined) {
        Toast.fail('请选择体检日期');
        return;
      }

      if (this.setBookedTime.length > 0 && this.setBookedTimeSelected == undefined) {
        Toast.fail('请选择体检时间段');
        return;
      }

      if (this.bookedPatient.bookedType != 2 && this.checkedPackages.length <= 0 && this.chooseGroup.length <= 0) {
        Toast.fail('您还未选择项目，请先选择');
        return;
      }

      this.makeOrder();
    },
    //查询预约时间段
    getSetBookedTime: function getSetBookedTime(bookedDate) {
      var _this14 = this;

      if (bookedDate != null) {
        bookedDate = bookedDate.replace(RegExp("-", "g"), "");
        var params = {
          bookedDate: bookedDate,
          checkLine: this.bookedPatient.enterQueue,
          institutionId: window.g.VUE_APP_INSTITUTIONID
        };

        _getSetBookedTime(params).then(function (res) {
          if (res.code == 200) {
            _this14.setBookedTime = res.data;
          }
        });
      }
    },
    //添加订单
    makeOrder: function makeOrder() {
      var _this15 = this;

      var chooseGroup = this.chooseGroup;
      var checkedPackages = this.checkedPackages;
      var param = {
        bookedtype: this.bookedPatient.bookedType,
        bookedno: this.bookedPatient.bookedNo,
        checkdate: this.checkDate,
        timeslot: this.setBookedTimeSelected,
        patientid: this.user.patientid,
        packageid: this.checkedPackageIds[0],
        institutionid: window.g.VUE_APP_INSTITUTIONID,
        groupIdList: this.result,
        chooseGroup: chooseGroup,
        checkedPackages: checkedPackages
      };
      console.log(param);
      updateOrderBookedDateUnit(param).then(function (res) {
        console.log("res.data.deptCestriction", res.data.deptCestriction);

        if (res.data.deptCestriction) {
          Dialog.alert({
            title: '温馨提示',
            message: res.data.deptCestriction
          });
        }

        if (res.code == 200) {
          if (res.data == null || res.data == 0) {
            Dialog.alert({
              title: '温馨提示',
              message: res.msg
            });
          } else {
            _this15.showSuccess = true;
          }
        }
      });
    },
    //跳转
    toOrders: function toOrders() {
      // ZLS 20240816 companyOrders 改为 Orders
      this.$router.push({
        name: 'orders'
      });
    },
    loginOut: function loginOut() {
      var _this16 = this;

      //如果有用户信息，则不进行微信登录
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      var params = {
        wechatid: ""
      };

      if (userinfo != undefined) {
        params = {
          wechatid: userinfo.openid
        };
      }

      unbindingWechat(params).then(function (res) {
        if (res.code == 200) {
          // Toast("解绑成功！")
          window.localStorage.removeItem("loginuser");
          localStorage.removeItem("token");

          _this16.$router.push({
            name: 'login'
          });
        }
      });
    }
  }
};